import React from "react";
import CalendarPicker from "../components/calendar-picker";
import KilometersItem from "../components/kilometors-item";

export default function Mileage({ onSelectedDateFrom, dateFrom }) {
  return (
    <>
      <CalendarPicker
        label={"From"}
        isStanAlone
        onSelected={(value, str) => onSelectedDateFrom(value, str)}
        value={dateFrom}
        id="mileage-calendar-component"
      />
      <KilometersItem id="mileage-kilometer-component" />
    </>
  );
}
